import { render, staticRenderFns } from "./ReferencePicturesHeader.vue?vue&type=template&id=24800479&lang=pug"
import script from "./ReferencePicturesHeader.vue?vue&type=script&lang=js"
export * from "./ReferencePicturesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports